/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import ReportsCard from '../../components/ReportsCard';
// import sumByCC from '../../assets/reporting_views/sumBySource/sbcc.png';
import sumBySourceDownload from '../../assets/reporting_views/sumBySource/sbs_download.png';
import sumBySourceTableau from '../../assets/reporting_views/sumBySource/sbs_tableau.png';

function SSRMultiChannelLanding() {
  useEffect(() => {
    document.title = 'MissionPortal | SSR Multi-Channel';
  }, []);

  const { client } = useParams();

  return (
    <div className="App">
      <header className="App-header">
        <h2>Strategic Services - Multi-Channel</h2>
      </header>
      <h5>
        View client revenue and sum by source reports.
        <a target="_blank" href="https://missionwired.atlassian.net/wiki/spaces/AAI/overview" rel="noreferrer"> Digital Co-Op Confluence Space.</a>
      </h5>
      <Box sx={{ flexGrow: 1 }}>
        <div className="reporting-row-container">
          {/* this is part of V2 so commenting out for now */}
          {/* <ReportsCard
            image={sumByCC}
            imageAlt="Sum by channel category report"
            title="Sum by Channel Category: Month to Date"
            description="Quickly view total monthly client revenue aggregated by channel category (Email, SMS-Shortcode, SMS-Longcode)."
            bullets={[]}
            route={`/client/${client}/Strategy/Multi-Channel/SBCC`}
            buttonText="View Report"
          /> */}
          <ReportsCard
            image={sumBySourceDownload}
            imageAlt="Sum by source/category download"
            title="Sum by Source/Category Download"
            description="Downloadable report aggregating revenue by:"
            bullets={['Channel Category', 'Source Name']}
            route={`/client/${client}/Strategy/Multi-Channel/SBS/Download`}
            buttonText="View Report"
          />
          <ReportsCard
            image={sumBySourceTableau}
            imageAlt="Sum by source report"
            title="Sum by Source: Tableau Report"
            description="See client revenue by:"
            bullets={['Channel: Gifts and revenue raised, by day by channel, further broken out by code type and source', 'Codes: Gifts and revenue raised, by day by code, with channel category and source', 'Bundling: Bundling gifts and revenue raised broken out by source']}
            route={`/client/${client}/Strategy/Multi-Channel/SBS/Tableau`}
            buttonText="View Report"
          />
        </div>
      </Box>
    </div>
  );
}

export default SSRMultiChannelLanding;
